import { useReactiveVar } from '@apollo/client';

import type {
  CreateVitaDocumentFileAttachmentsInput,
  VitaDocumentLanguage,
} from '@xingternal/crate-common-graphql-types';
import type { VitaDocumentFragment } from '@xingternal/crate-lebenslauf-graphql';
import { sharedClientDocumentVariable } from '@xingternal/crate-lebenslauf-shared-client-document-variable';

export const useReadVitaReactiveVariable = (): VitaDocumentFragment &
  CreateVitaDocumentFileAttachmentsInput & {
    validation: { invalidFormInputNames: string[] };
    language?: VitaDocumentLanguage | null;
    token?: string | null;
    id?: string | null;
    showAnschreibenBanner: boolean;
    suggestionTrackingToken?: string;
  } => {
  return useReactiveVar(sharedClientDocumentVariable);
};
